/* jshint esversion: 6 */

class JournalCtrl {

	constructor(
		$scope,
		$timeout,
		LocationService
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.locationService = LocationService;
		this.filters = window.filters || {};
		this.journals = window.journals || [];
		this.selectedFilters = [];
		this.deserializeFilters();
		this.applyFilters();
		this.$scope.toggle = true;
	}

	deserializeFilters() {
		const locationFilters = this.locationService.deserialize('filters') || {};
		Object.keys(this.filters).forEach(x => {
			const filter = this.filters[x];
			switch (x) {
				default:
					filter.doFilter = (item, value) => {
						return item[x] === value;
					};
			}
			filter.options.unshift({
				label: this.filters[x].placeholder,
				value: null,
			});
			const selectedOption = filter.options.find(o => Boolean(o.value === (locationFilters[x] || null)));
			filter.value = selectedOption.value;
			filter.placeholder = selectedOption.label;
		});
		return filters;
	}

	serializeFilters() {
		const filters = {};
		Object.keys(this.filters).forEach(x => {
			const filter = this.filters[x];
			if (filter.value !== null) {
				filters[x] = filter.value;
			}
		});
		// console.log('ReferenceCtrl.serializeFilters', filters);
		//--this.locationService.serialize('filters', filters);
		return filters;
	}

	setFilteredImage(item, filter) {
		// nope
	}

	applyFilters() {
		this.serializeFilters();

		const selectedFilters = Object.keys(this.filters).map((x) => this.filters[x]).filter(x => x.value !== null);
		let filteredItems = this.journals.slice();
		// console.log('selectedFilters', selectedFilters.map(x => x.value).join(', '));
		if (selectedFilters.length) {
			filteredItems = filteredItems.filter(item => {
				item.filteredImage = item.image;
				let has = true;
				selectedFilters.forEach(filter => {
					const hasFilter = filter.doFilter(item, filter.value);
					if (hasFilter) {
						this.setFilteredImage(item, filter);
					}
					has = has && hasFilter;
				});
				return has;
			});
		} else {
			filteredItems.forEach(item => item.filteredImage = item.image);
		}
		// console.log(filteredItems, selectedFilters);
		this.selectedFilters = selectedFilters;
		this.filteredItems = [];
		this.$timeout(() => {
			this.filteredItems = filteredItems;
			this.updateFilterStates(filteredItems);
			// delayer for image update
		}, 50);
	}

	updateFilterStates(items) {
		// console.log('updateFilterStates', items);
		Object.keys(this.filters).forEach(x => {
			const filter = this.filters[x];
			filter.options.forEach(option => {
				let has = false;
				if (option.value) {
					let i = 0;
					while (i < items.length && !has) {
						const item = items[i];
						has = filter.doFilter(item, option.value);
						i++;
					}
				} else {
					has = true;
				}
				option.disabled = !has;
			});
			// console.log(filter.options);
		});
	}

	setFilter(item, filter) {
		item = item || filter.options[0];
		filter.value = item.value;
		filter.placeholder = item.label;
		this.applyFilters();

	}

	toggleFilter(item, filter) {
		if (filter.value === item.value) {
			filter.value = null;
			filter.placeholder = item.label;
		} else {
			filter.value = item.value;
			filter.placeholder = filter.options[0].label;
		}
		this.applyFilters();
	}

	removeFilter(filter) {
		this.setFilter(null, filter);
	}

	removeAll() {
		const removing = {}
		Object.keys(this.filters).forEach(key => {
			removing[key] = this.filters[key];
		});
		Object.keys(removing).forEach(key => {
			const filter = removing[key];
			this.removeFilter(filter);
		});
		this.applyFilters();
	}
}

JournalCtrl.$inject = ['$scope', '$timeout', 'LocationService'];

export default JournalCtrl;
